module.exports = __webpack_public_path__ + "static/media/zhengs2-0.b92811e6.png";